import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IAdministratorDocument } from "../interface/IAdministratorDocument";
import { IResult } from "../interface/IResult";
import { IAdministratorSelect } from "../interface/IAdministratorSelect";

enum administratorServiceEnum {
  save = "/",
  getById = "/",
  getAll = "/",
  getBasic = "/basic",
  edit = "/",
  downloadDocument = '/download/document',
  getAllWithOcr = '/all/ocr',
  getReport = '/report'
}

export default class AdministratorService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/administrator");
  }
  public save = async data => await this.POST(administratorServiceEnum.save, data);
  public getById = async id => await this.GET(administratorServiceEnum.getById + id);
  public getAll = async () => await this.GET(administratorServiceEnum.getAll);
  public getBasicAll = async () => await this.GET(administratorServiceEnum.getBasic);
  public edit = async data => await this.PUT(administratorServiceEnum.edit, data);
  public getAllWithOcr = async (): Promise<IResult<IAdministratorSelect[]>> => this.GET(administratorServiceEnum.getAllWithOcr);
  public getReport = async () => await this.GET(administratorServiceEnum.getReport);

  public downloadDocument = async (file: IAdministratorDocument) => {
    const endpoint = administratorServiceEnum.downloadDocument + "/?documentPath=" + file.document.path;
    const data = await this.GET(endpoint);
    this.downloadBase64File(data.data, 'application/octet-stream', file.document.fileName)
  };

  private downloadBase64File = (base64Data, contentType, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

}


// WEBPACK FOOTER //
// ./src/services/api/Administrator.service.ts